import { FunctionComponent } from "react";
import ChipBase, { ChipBaseType } from "../base";

export const Chip: FunctionComponent<ChipBaseType> = (props) => {
  return <ChipBase {...props} />;
};

Chip.displayName = "Chip";

export default Chip;
